import { default as IconDialogButton } from "./IconDialogButton.vue";
import { default as PrintButton } from "./PrintButton.vue";
import { default as RevertButton } from "./RevertButton.vue";

export const Button = {
    IconDialog: IconDialogButton,
    Print: PrintButton,
    Revert: RevertButton,
};
